import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Checkbox } from "./ui/checkbox";
import { ShieldCheck } from "lucide-react";

const KEY = "gcl_age_ok";

export function AgeGate() {
  const [open, setOpen] = useState(() => localStorage.getItem(KEY) !== "1");
  const [checked, setChecked] = useState(false);

  const accept = () => { localStorage.setItem(KEY, "1"); setOpen(false); };

  return (
    <Dialog open={open}>
      <DialogContent className="glass-strong max-w-lg border-celeste-or/25 text-celeste-ivoire [&>button:last-of-type]:hidden" data-testid="age-gate-modal">
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-14 w-14 items-center justify-center rounded-full border border-celeste-or/40 bg-celeste-or/10">
            <ShieldCheck className="h-7 w-7 text-celeste-or" />
          </div>
          <DialogTitle className="text-center font-serif text-2xl text-celeste-ivoire">Confirmation d'âge</DialogTitle>
        </DialogHeader>
        <p className="text-center text-sm text-celeste-lilas">
          Guidance Céleste Live est strictement réservé aux personnes majeures. Les guidances sont proposées à des fins de
          réflexion personnelle et de divertissement. Elles ne remplacent jamais un avis médical, psychologique, juridique
          ou financier et ne garantissent aucun résultat futur.
        </p>
        <label className="mt-2 flex items-start gap-3 rounded-xl border border-celeste-violet/30 bg-celeste-night/50 p-3 text-sm text-celeste-lilas cursor-pointer">
          <Checkbox data-testid="age-confirm-checkbox" checked={checked} onCheckedChange={(v) => setChecked(!!v)} className="mt-0.5 border-celeste-or data-[state=checked]:bg-celeste-or" />
          Je certifie avoir 18 ans ou plus et j'accepte les conditions d'utilisation ainsi que l'avertissement ci-dessus.
        </label>
        <Button data-testid="age-confirm-btn" disabled={!checked} onClick={accept} className="gold-btn mt-2 w-full font-semibold disabled:opacity-40">
          Entrer sur la plateforme
        </Button>
      </DialogContent>
    </Dialog>
  );
}
